import { createCustomAction } from 'typesafe-actions';
import { VIEWITEM_FILTER_EXPRESSIONS_GENERATED } from './constants';
import { ViewItemFilterExpressionsGenerated } from './reducer';

export const viewItemFilterExpressionsGenerated = createCustomAction(VIEWITEM_FILTER_EXPRESSIONS_GENERATED, type => {
    return (payload: ViewItemFilterExpressionsGenerated) => ({ type, payload });
});
